import { render, staticRenderFns } from "./JeecgDemoModal.vue?vue&type=template&id=6c20b64f&scoped=true"
import script from "./JeecgDemoModal.vue?vue&type=script&lang=js"
export * from "./JeecgDemoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c20b64f",
  null
  
)

export default component.exports